export enum STOCK_PERMISSIONS {
  STOCK_VIEW = 'STOCK_VIEW',
  STOCK_WRITE = 'STOCK_WRITE',
}
